import React from "react";
import { FormattedMessage } from "react-intl";
import { RAW_STATUS_TO_VOLUME, VOLUME_COLORS, VOLUME_LABEL_IDS, VOLUME_OUTLINE_TEXT, isCommunicationStatus, } from "../../utils/volumeConstants";
import css from "./VolumeStatusBadge.module.css";
export var volumeStatusOf = function (depositStatus) { var _a; return (_a = RAW_STATUS_TO_VOLUME[depositStatus]) !== null && _a !== void 0 ? _a : "na"; };
export var VolumeStatusBadge = function (_a) {
    var _b;
    var status = _a.status;
    var colors = VOLUME_COLORS[status];
    var communication = isCommunicationStatus(status);
    // Colours stay inline: VOLUME_COLORS is the only palette, a CSS module would need a copy of it.
    return (React.createElement("span", { "data-test-status-badge": status, className: "".concat(css.badge, " ").concat(communication ? css.communication : css.substantive), style: communication
            ? {
                color: (_b = VOLUME_OUTLINE_TEXT[status]) !== null && _b !== void 0 ? _b : colors.color,
                borderColor: colors.border,
            }
            : { background: colors.bg, color: colors.color } },
        React.createElement(FormattedMessage, { id: VOLUME_LABEL_IDS[status] })));
};
